var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right--chart_3"},[_c('h3',{staticClass:"right--chart_3_title"},[_vm._v(" "+_vm._s(this.params.hxcs_position)+"部位检查医院使用品牌列表 ")]),_c('dv-scroll-board',{staticClass:"right--scroll",attrs:{"config":_vm.dataConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }